import React from 'react';
import { connect } from 'react-redux';
import { itemProps } from '../ReturnOrders/proptypes';
import { ItemContainer, ItemImage, ItemImageContainer } from './styles';
import { ItemProperties } from './ItemProperties/itemProperties';
import { Checkmark } from './Checkmark';

const mapStateToProps = ({ page: { locale } }) => ({
  locale,
});

export const ReturnItem = ({
  itemIndex,
  item,
  item: { item_name: itemName, product_image_url: productImageUrl },
  readOnly = false,
  imageSize = 'large',
  showCheckmark = true,
  onClick,
  selected,
  disabled,
  borderless = false,
  eligibleStatus,
  itemQtyKey,
  className,
  locale,
}) => {
  const onKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick({ item, event });
    }
  };

  return (
    <ItemContainer
      readOnly={readOnly}
      borderless={borderless}
      disabled={disabled}
      className={[
        'returnItem-module_item_container_',
        'return-item-container',
        'return-eligible-item',
        className,
      ].join(' ')}
      {...(!disabled && !readOnly
        ? {
            tabIndex: 0,
            role: 'button',
            onKeyDown,
            selected,
            onClick: (event) => {
              onClick({ event, item });
            },
          }
        : {})}
    >
      <ItemImageContainer className="returnItem-module_item_image_container_" imageSize={imageSize}>
        <ItemImage
          alt=""
          src={productImageUrl || '/r2/img/blindItemImage.svg'}
          role="img"
          className={[`return-item-${itemIndex}-image`, 'returnItem-module_item_image_'].join(' ')}
        />
      </ItemImageContainer>
      <ItemProperties {...{ itemIndex, itemName, item, eligibleStatus, itemQtyKey, locale }} />
      {showCheckmark && <Checkmark checked={selected} />}
    </ItemContainer>
  );
};

export const ItemCard = connect(mapStateToProps)(ReturnItem);

ReturnItem.propTypes = itemProps;
